namespace SP {
    export interface StockInfo {
        stockId: string;
        stockName: string;
        stockPrefix: string;
    }
}